module.exports = __webpack_public_path__ + "img/qa_close.a78220eb.png";